<template>
  <div class="problem">
    <div class="problemitem" v-for="(item,index) in data" :key="index">
      <p>
        <span class="Magnifyingglass">
          <span class="circle"></span>
        </span>
        {{ item.QUESTION_TITLE }}
      </p>
      <p>
        <span class="letter">
          A
        </span>
        {{ item.ANSWER }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data"],
  data() {
    return {
      problemList: Array(4).fill({
        problem: "该产品的保障责任有哪些?",
        question:
          "暴雨、洪水、内涝、风灾、客灾、冻灾;病虫草鼠害;早灾;地震:泥石流、山体滑坡造成的水稻作物损失。",
      }),
    };
  },
  computed: {},
  created() {},
  methods: {},
  mounted() {},
};
</script>

<style lang='scss' scoped >
.problem {
  width: 94%;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0 20px;

  .problemitem {
    width: 100%;
    padding: 10px;
    background-color: #fff;
    box-sizing: border-box;
    margin-top: 20px;

    P {
      margin-top: 6px;
      height: 30px;
      line-height: 30px;
      position: relative;
      padding-left: 30px;
      box-sizing: border-box;
    }
    .letter,
    .Magnifyingglass {
      position: absolute;
      left: -8px;
      top: 4px;

      display: inline-block;

      display: inline-block;
      height: 22px;
      width: 30px;
      border-radius: 11px;
      background-color: #ff5109;
      display: flex;
      justify-content: center;
      align-items: center;
      .circle {
        width: 14px;
        height: 14px;
        border-radius: 50%;
        border: 2px solid #fff;
        box-sizing: border-box;
        position: relative;
        &::after {
          content: " ";
          position: absolute;
          width: 4px;
          height: 2px;
          background-color: #fff;
          right: -2px;
          bottom: -3px;
          transform: rotate(45deg);
        }
      }
    }
    .letter {
      background-color: #0daf53;
      color: #fff;
    }
    &:last-child {
      margin-bottom: 20px;
    }
  }
}
</style>
